import React from 'react';

const Footer: React.FC = () => {
  return false;
};

export default Footer;
